import { render } from "./ClientSites.vue?vue&type=template&id=39c6f944"
import script from "./ClientSites.vue?vue&type=script&lang=js"
export * from "./ClientSites.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Saad/Documents/GitHub/link-portal/link/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__